<template>
    <div>
        <form ref="adjustForm">
            <!-- First Row auction date -->
            <div class="w-full flex flex-row mt-4 ml-5">
                <div class="w-full lg:w-2/12 my-auto pl-1">
                    <label class="disabled text-left">{{ $t('shared.auction.edit_auction_form.auction_date') }}</label>
                </div>
                <div class="w-full lg:w-9/12 disabled pl-4">
                    {{ auction.auction_date | formatDay }}
                </div>
            </div>

            <!-- Auction Name -->
            <div class="w-full flex flex-row mt-4 ml-5">
                <div class="w-1/2 lg:w-2/12 my-auto pl-1">
                    <label class="text-left" for="auctionName">{{ $t('shared.auction.edit_auction_form.auction_name') }}</label>
                </div>
                <div class="w-1/2 lg:w-10/12 pl-1 pr-5">
                    <input ref="auctionName"
                           type="text"
                           name="auctionName"
                           id="auctionName"
                           class="w-full"
                           maxlength="255"
                           @change="formUpdated"
                           :class="{'error' : !isAuctionNameValid}"
                           :placeholder="form.auctionName"
                           v-model="form.auctionName">
                </div>
            </div>


            <!-- product id Shop HQ Price -->
            <div class="w-full flex flex-row mt-4">
                <div class="w-full flex lg:w-1/2 my-auto ml-5">
                    <div class="w-1/3 my-auto pl-1">
                        <label class="text-left" for="productId">{{ $t('shared.auction.edit_auction_form.product_id') }}</label>
                    </div>
                    <div class="w-1/3 pl-3">
                        <input ref="productId"
                               type="text"
                               name="productId"
                               id="productId"
                               size="12"
                               maxlength="20"
                               @change="formUpdated"
                               :class="{'error' : !isProductIdValid}"
                               :placeholder="form.productId"
                               v-model="form.productId">
                    </div>
                </div>
                <div class="w-full flex lg:w-1/2 my-auto ml-5">
                    <div class="w-1/3 my-auto pl-1">
                        <label class="text-left"
                               for="shopPrice">{{ $t('shared.auction.edit_auction_form.shop_price' + this.$page.props.tenant.labels_key, { currency: curr }) }}</label>
                    </div>
                    <div class="w-1/3 pl-3">
                        <input ref="shopPrice"
                               type="number"
                               name="shopPrice"
                               id="shopPrice"
                               class="w-1/2"
                               min="0"
                               @change="formUpdated"
                               :class="{'error' : !isShopPriceValid}"
                               :placeholder="form.shopPrice"
                               v-model="form.shopPrice">
                    </div>
                </div>
            </div>


            <!--Available Qty and Max Price-->
            <div class="w-full flex flex-row mt-4">
                <div class="w-full flex lg:w-1/2 my-auto ml-5">
                    <div class="w-1/3 my-auto pl-1">
                    <label for="availableQuantity"
                           class="w-1/2 text-left">{{ $t('shared.auction.edit_auction_form.available_quantity') }}</label>
                    </div>
                    <div class="w-1/3 pl-3">
                        <input ref="availableQuantity"
                               type="number"
                               name="availableQuantity"
                               id="availableQuantity"
                               class="w-1/2"
                               @change="formUpdated"
                               :class="{'error' : !isAvailableQuantityValid}"
                               :placeholder="form.availableQuantity"
                               v-model="form.availableQuantity"
                               :min="0">
                    </div>
                </div>
                <div class="w-full flex lg:w-1/2 my-auto ml-5">
                    <div class="w-1/3 my-auto pl-1">
                        <label class="text-left" for="maxPrice">{{ $t('shared.auction.edit_auction_form.max_price', { currency: curr }) }}</label>
                    </div>
                    <div class="w-1/3 pl-3">
                        <input ref="maxPrice"
                               type="number"
                               name="maxPrice"
                               id="maxPrice"
                               class="w-1/2"
                               min="0"
                               @change="formUpdated"
                               :class="{'error' : !isMaxPriceValid}"
                               :placeholder="form.maxPrice"
                               v-model="form.maxPrice">
                    </div>
                </div>
            </div>


            <!-- price drops TODO: // make this responsive-->
            <div class="w-full mt-5 pt-1">
                <table class="table-default">
                    <thead>
                        <tr>
                            <th scope="col" class="w-2/12">{{ $t('shared.auction.edit_auction_form.price_drop_phase') }}</th>
                            <th scope="col" class="w-3/12">{{ $t('shared.auction.edit_auction_form.number_of_levels') }}</th>
                            <th scope="col" class="w-3/12">{{ $t('shared.auction.edit_auction_form.price_drop_price', { currency: curr }) }}</th>
                            <th scope="col" class="w-2/12">{{ $t('shared.auction.edit_auction_form.start_quantity') }}</th>
                            <th scope="col" class="w-2/12">{{ $t('shared.auction.edit_auction_form.factor') }}</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-200 bg-white">
                        <tr v-for="(level, index) in auction.levels" :key="index">
                            <td>{{ level.level_sequence }}</td>
                            <td>
                                <input ref="numberOfLevels_{{index}}"
                                       type="number"
                                       :name="'numberOfLevels_' + index"
                                       :id="'numberOfLevels_' + index"
                                       min="0"
                                       @change="formUpdated"
                                       :class="{'error' : !isNumberOfLevelsValid(form.numberOfLevels[index])}"
                                       :placeholder="form.numberOfLevels[index]"
                                       v-model="form.numberOfLevels[index]">
                            </td>
                            <td>
                                <input ref="pdPrice_{{index}}"
                                       type="number"
                                       :name="'pdPrice_' + index"
                                       :id="'pdPrice_' + index"
                                       min="0"
                                       @change="formUpdated"
                                       :max="form.maxPrice"
                                       :class="{'error' : !isPdPriceValid(form.pdPrice[index])}"
                                       :placeholder="form.pdPrice[index]"
                                       v-model="form.pdPrice[index]">
                            </td>
                            <td>
                                <input ref="startQuantity_{{index}}"
                                       type="number"
                                       :name="'startQuantity_' + index"
                                       :id="'startQuantity_' + index"
                                       min="0"
                                       @change="formUpdated"
                                       :max="maxStartQuantity(index, form.startQuantity[index])"
                                       :class="{'error' : !isStartQuantityValid(form.startQuantity[index])}"
                                       :placeholder="form.startQuantity[index]"
                                       v-model="form.startQuantity[index]">
                            </td>
                            <td>
                                <input ref="factor_{{index}}"
                                       type="number"
                                       :name="'factor_' + index"
                                       :id="'factor_' + index"
                                       min="1.00"
                                       step="0.01"
                                       max="10"
                                       @change="formUpdated"
                                       :class="{'error' : !isFactorValid(form.factor[index])}"
                                       :placeholder="form.factor[index]"
                                       v-model="form.factor[index]">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form>
    </div>
</template>


<script>
import Icon from "../Icon";

export default {
    props: {
        auction: Object // Raw Auction with its levels
    },
    data() {
        return {
            form: {
                auctionDate: this.auction?.date_start,
                auctionName: this.auction?.auction_name,
                productId: this.auction?.product_id,
                shopPrice: this.auction?.shop_price,
                availableQuantity: this.auction?.available_quantity,
                maxPrice: parseInt(this.auction?.max_price),
                numberOfLevels: [],
                pdPrice: [],
                startQuantity: [],
                factor: [],
            }
        }
    },
    components: {
        Icon
    },
    mounted() {
        this.form.numberOfLevels = this.auction?.levels?.map(lvl => {
            return lvl.level_quantity;
        });
        this.form.pdPrice = this.auction?.levels?.map(lvl => {
            return lvl.start_price;
        });
        this.form.startQuantity = this.auction?.levels?.map(lvl => {
            return lvl.start_quantity;
        });
        this.form.factor = this.auction?.levels?.map(lvl => {
            return lvl.quantity_increase_factor;
        });
    },
    computed: {
        isAuctionNameValid() {
            return this.form.auctionName?.length > 0;
        },
        isProductIdValid() {
            return this.form.productId?.length > 0;
        },
        isShopPriceValid() {
            return parseFloat(this.form.shopPrice) > 0.0;
        },
        isAvailableQuantityValid() {
            return parseInt(this.form.availableQuantity) > 0;
        },
        isMaxPriceValid() {
            return parseInt(this.form.maxPrice) > 0;
        },
        curr() {
            return this.$page.props.global.localization.currencySymbol;
        }
    },
    methods: {
        checkForm: function () {
            let numberOfLevelsAreValid = !this.form.numberOfLevels.some(value => this.isNumberOfLevelsValid(value) === false );
            let pdPricesAreValid = !this.form.pdPrice.some(value => this.isPdPriceValid(value) === false );
            let startQuantitiesAreValid = !this.form.startQuantity.some(value => this.isStartQuantityValid(value) === false );
            let factorsAreValid = !this.form.factor.some(value => this.isFactorValid(value) === false );
            let res =
                this.isAuctionNameValid &&
                this.isProductIdValid &&
                this.isShopPriceValid &&
                this.isAvailableQuantityValid &&
                this.isMaxPriceValid &&
                numberOfLevelsAreValid &&
                pdPricesAreValid &&
                startQuantitiesAreValid &&
                factorsAreValid;
            return res;
        },
        isNumberOfLevelsValid(number) {
            return parseInt(number) > 0;
        },
        isPdPriceValid(price) {
            return parseInt(price) > 0.0;
        },
        isStartQuantityValid(startQuantity) {
            return parseInt(startQuantity) > 0;
        },
        isFactorValid(factor) {
            return parseFloat(factor) > 0.0; // TODO: TBD could this be lower than 1.0?!!!
        },
        maxStartQuantity(index, quantity) {
            // TODO: do a rough calculation whether the start quantity is ok
            // should take into account previous levels
            // calculate current amount, but leave last level as it is
        },
        formUpdated() {
            this.$emit('changed');
        }
    }
}
</script>
